import { StringConstants } from "./StringConstants";

/** API base URL — set in `.env` as REACT_APP_API_URL (no trailing slash). */
const apiBase = String(
  process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    ""
)
  .trim()
  .replace(/\/$/, "");

if (!apiBase && process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.warn(
    "[UrlConstants] REACT_APP_API_URL missing — falling back to http://localhost:5001"
  );
}

const ip2 = apiBase || "http://localhost:5001";

class UrlConstants extends StringConstants {
  url_prod = ip2;
  url_dev = "https://api-uat.xyz.com/xyz";

  // Dashboard
  DASHBOARD = `${this.url_prod}/dashboard`;
  DASHBOARDATTENDANCE = `${this.url_prod}/dashboardAttendance`;
  DASHBOARDMYATTENDANCE = `${this.url_prod}/dashboardAttendance/`;
  DASHBOARDPROJECT = `${this.url_prod}/dashboardProject`;
  DASHBOARDMYLEAD = `${this.url_prod}/dashboardMylead`;
  DASHBOARDALLLEADS = `${this.url_prod}/dashboardAllLead`;
  DASHBOARDMYTEAM = `${this.url_prod}/getTeamIdUserWise/`;
  GETDAHBOARDSOURCECOUNT = `${this.url_prod}/getDashboardSourceCount`;
  GETDAHBOARDFUNNELSTAGECOUNT = `${this.url_prod}/getDashboardFunnelStageCount`;
  GETDAHBOARDSTAGECOUNT = `${this.url_prod}/getDashboardStageCount`;
  GETMYDASHBOARDSOURCECOUNT = `${this.url_prod}/getMyDashboardSourceCount`;
  GETMYDASHBOARDSTAGECOUNT = `${this.url_prod}/getMyDashboardPreSaleStageCount`;
  GETMYDASHBOARDPRESALESSTAGECOUNT = `${this.url_prod}/getMyDashboardPreSaleStageCount`;
  GETMYDASHBOARDSALESTAGECOUNT = `${this.url_prod}/getMyDashboardSaleStageCount`;
  GETMYDASHBOARDREMINDER = `${this.url_prod}/getDashboardReminder`;
  GETDAHBOARDPARENTSTAGECOUNT = `${this.url_prod}/getDashboardParentStageCount`;
  DASHBOARD_V2 = `${this.url_prod}/dashboard/v2`;



  // View Paths
  landingViewPath = "/";
  loginViewPath = "/login";
  forgotPasswordViewPath = "/forgot-password";
  changePasswordViewPath = "/changepwd";
  resetPasswordLinkViewPath = "/reset-password-link";
  updatePasswordViewPath = "/update-password";
  SignInViewPath = "/sign-in";
  mobileVerificationViewPath = "/mobile-verification";
  signUpViewPath = "/sign-up";
  onBoadingSelectIndustryViewPath = "/onboading-select-industry";

  dashboardViewPath = "/dashboard-admin";
  dashboardViewPathCrm = "/dashboard-crm";
  dashboardViewPathHr = "/dashboard-hr";
  dashboardViewPathMy = "/my-dashboard";
  settingsViewPath = "/setting";
  accountSettingsViewPth = "/setting/account";
  accountOrganizationPath = "/setting/account/organization";
  accountSecurityPath = "/setting/account/security";
  accountSystemPath = "/setting/account/system";
  accountProfilePath = "/setting/account/profile";
  accountPreferencesPath = "/setting/account/preferences";
  accountIntegrationsPath = "/setting/account/integrations";
  automationLeadFlowPath = "/setting/automation-lead-flow";
  automationLeadFlowNewPath = "/setting/automation-lead-flow/new";
  automationLeadFlowEditPath = "/setting/automation-lead-flow/edit/:id";
  organizationsAdminPath = "/organizations";
  auditLogsPath = "/audit-logs";
  metaDataViewPath = "/setting/meta-data";
  metaListViewPath = "/setting/meta-data/meta-list";
  metaGradeListPath = "/setting/meta-data/grades";
  metaLeadSourcesPath = "/setting/meta-data/lead-sources";
  ADDDEPARTMENTPAGE = "/setting/meta-data/meta-list/add";
  metaTeamListViewPath = "/setting/meta-data/meta-team-list";
  metaHierarchyListViewPath = "/setting/meta-data/meta-hierarchy-list";
  metaProjectLocationListViewPath = "/setting/meta-data/meta-project-location";
  metaProjectZonesListViewPath = "/setting/meta-data/meta-project-zones";
  metaProjectFilterListViewPath = "/setting/meta-data/meta-project";
  metaProjectListViewPath = "/setting/meta-data/project-meta";
  meetingListViewPath = "/meeting";
  createMeetingViewPath = "/create-meeting";
  bookingListViewPath = '/bookings'
  customerListViewPath = "/customer";
  customerDetailsPath = "/customer/:id";
  enquiryViewPath = "/enquiry";
  serviceLeadsViewPath = "/service-leads";
  subscribeLeadsViewPath = "/subscribe-leads";


  customerViewPath = "/customer";
  locationListViewPath = "/setting/meta-data/location-list";
  metaStageListPath = "/meta-data/meta-stage"
  metaProjectListPath = "/meta-data/meta-project-list"

  leaveViewPath = "/leave";
  allLeaveViewPath = "/all-Leave";
  teamViewPath = "/team";
  addTeamViewPath = "/team/add";
  editTeamViewPath = "/team/edit/:id";
  archiveMember = "/archive-member";
  addArchiveTeamViewPath = "/archive-member/add";
  editArchiveTeamViewPath = "/archive-member/edit/:id";
  viewArchiveLoanPath = "/archive-member/loans/:userId";
  attendanceViewpath = "/all-attendance";
  myattendanceViewpath = "/my-Attendance";
  salarySlipViewPath = "/salary-slip";
  TeamDashboardViewpath = "/team-dashboard";
  rolesPrivilegesViewPath = "/setting/account/rolesPrivileges";
  ADDROLEPAGE = "/setting/account/rolesPrivileges/add";
  EDITROLEPAGE = "/setting/account/rolesPrivileges/edit/:id";
  mylead = "/my-Lead";
  MYLEADADDPAGE = "/my-Lead/add";
  MYLEADEDITPAGE = "/my-Lead/edit/:id";
  teamleads = "/team-Leads";
  serviceleads = "/service-leads";
  subscribeleads = "/subscribe-leads";


  bulkUploade = "/bulk-upload";
  IMPORTLEADPAGE = "/bulk-upload/import";
  bulkAssign = "/bulk-assign";

  bulkUploadeProjectwise = "/bulk-upload-projectwise";
  IMPORTLEADPROJECTWISEPAGE = "/bulk-upload-projectwise/import";
  /** New scalable bulk wizard (leads) */
  leadsBulkUploadPath = "/leads-bulk-upload";
  /** Uploaded lead datasets / sets list */
  leadsBulkUploadSetsPath = "/leads-bulk-upload/sets";
  /** Call datasets — bulk rows that are not leads until converted */
  callDatasetsPath = "/call-datasets";
  callDatasetUploadPath = "/call-datasets/upload";
  /** Channel Partners */
  channelPartnersPath = "/channel-partners";
  channelPartnerDetailPath = "/channel-partners/:id";
  cpBulkUploadPath = "/channel-partners/bulk-upload";
  cpBulkUploadSetsPath = "/channel-partners/bulk-upload/sets";
  cpAddLeadPath = "/channel-partners/add-lead";
  /** Marketing */
  whatsappMarketingPath = "/marketing/whatsapp";
  whatsappMarketingCreatePath = "/marketing/whatsapp/create";
  whatsappMarketingDetailPath = "/marketing/whatsapp/:id";

  /** User Manuals */
  userManualPath = "/user-manual";
  aggregatorApi = "/aggregator-api";
  facebookAds = "/facebook-form";
  archiveLead = "/lead-archive";
  unmergedLeads = "/unmerged-leads";
  preSalesReports = "/pre-sales-reports"
  salesReports = "/sales-reports"
  sourceReports = "/source-reports"
  siteVisitReports = "/siteVisit-reports"
  projectReports = "/project-reports"
  closureReports = "/closure-reports"
  callLogs = "/call-logs"
  callingReport = "/calling-report"

  login = `${this.url_prod}/auth/login`;
  GETALLUSER = `${this.url_prod}/allUser`;
  GETALLDEACTIVEUSER = `${this.url_prod}/allDeactivatedUser`;
  GETALLLEADS = `${this.url_prod}/getForm`;
  GETFORMBYID = `${this.url_prod}/getForm/`;

  LEADDATA = `${this.url_prod}/getLeadList`;
  GETLEADBYID = `${this.url_prod}/getLead/`;
  HOMETATVALEADDATA = `${this.url_prod}/getEnquiries`;

  TEAMLEADDATA = `${this.url_prod}/getTeamLeadList`;

  LEADDATAASSIGN = `${this.url_prod}/getLeadListForReassign`;
  UPLOADLEAD = `${this.url_prod}/getUploadLead`;
  UPLOADLEADPROJECTWISE = `${this.url_prod}/getUploadMultipleLead`;
  MYLEAD = `${this.url_prod}/getMyLeadList`;
  MYLEADCONTACT = `${this.url_prod}/getLeadContactStage`;
  MYLEADSTAGELEAD = `${this.url_prod}/getLeadStageLead`;
  MYLEADSTAGEPROSPECT = `${this.url_prod}/getLeadStageProspect`;
  MYLEADSTAGEPOPPORTUNITY = `${this.url_prod}/getLeadStageOpportunity`;
  MYLEADSTAGECLOSURE = `${this.url_prod}/getLeadStageClosure`;


  passwordReset = `${this.url_prod}/auth/password-reset`;
  ADDUSEROFFICE = `${this.url_prod}/addUserOffice`;
  EDITPASSWORD = `${this.url_prod}/auth/change-password-by-Admin`;
  VERIFY_OTP = `${this.url_prod}/auth/verifyOtp`;
  PUNCHIN = `${this.url_prod}/punchIn`;
  CHECKPUNCHIN = `${this.url_prod}/checkPunchIn`;
  PUNCHOUT = `${this.url_prod}/punchOut`;
  UNMAPPEDPROJECT = `${this.url_prod}/getProjectUnMap`;

  // TEAMS
  GETALLUSERLEAVES = `${this.url_prod}/getUserApplyLeaveByIds`;

  REGISTEREMPLOYEE = `${this.url_prod}/auth/register`;
  REGISTERLEAD = `${this.url_prod}/addLead`;
  SAVEEMPLOYEEOFFICIALINFO = `${this.url_prod}/addUserOffice`;
  SAVEEMPLOYEEBANKINFO = `${this.url_prod}/addUserBank`;
  SAVEEMPLOYEEBANKDETAILS = `${this.url_prod}/addUserLeave`;

  GETEMPLOYEERECORDBYID = `${this.url_prod}/find/`;
  GETEMPLOYEEOFFICEDETAILBYID = `${this.url_prod}/findUserOffice/`;
  GETEMPLOYEEBANKDETAILBYID = `${this.url_prod}/findUserBank/`;
  GETEMPLOYEEDOCUMENTBYID = `${this.url_prod}/findDocument/`;
  GETEMPLOYEELEAVEDETAILBYID = `${this.url_prod}/findUserLeave/`;
  GETUSERBYDEATILSBYID = `${this.url_prod}/getUserApplyLeaveByIds/`;

  // employ Document
  IMAGEUPLOAD = `${this.url_prod}/upload-image`;
  ADDUSERDOC = `${this.url_prod}/addUserDoc`;
  GETUSERDOC = `${this.url_prod}/getUserDoc/`;

  GETCOUNTRY = `${this.url_prod}/getCountry`;
  GETSTATEBYCOUNTRYID = `${this.url_prod}/getState/`;
  GETSTATE = `${this.url_prod}/getState`;

  GETCITYBYSTATEID = `${this.url_prod}/getCity/`;
  GETCITY = `${this.url_prod}/getCity`;

  GETTIMEZONEBYCOUNTRYID = `${this.url_prod}/getTimezone/`;

  // GETEMPLOYEESALARYDETAILBYID = `${this.url_prod}/findUserLeave/`;
  UPDATEEMPLOYEEPERSONALDETAIL = `${this.url_prod}/updateUserPersonal`;
  UPDATELEADDETAIL = `${this.url_prod}/updateLead`;
  UPDATELEADEXPORTDETAILS = `${this.url_prod}/addUploadLead`;
  UPDATELEADEXPORTDETAILS2 = `${this.url_prod}/addUploadMultipleLead`;
  UPDATELEADUPLOADEDETAILS = `${this.url_prod}/updateUploadLead`;
  UPDATELEADUPLOADEDETAILS2 = `${this.url_prod}/updateUploadMultipleLead`;
  UPDATEEMPLOYEEOFFICIALDETAIL = `${this.url_prod}/updateUserOffice`;
  UPDATEEMPLOYEEBANKINFO = `${this.url_prod}/updateUserBank`;
  UPDATEEMPLOYEELEAVEINFO = `${this.url_prod}/updateUserLeave`;
  GETEMPLOYEESALARYDETAILBYID = `${this.url_prod}/findUserSalaryDeclaration/`;
  SAVEEMPLOYEESALARYDETAILS = `${this.url_prod}/addUserSalary`;
  UPDATEEMPLOYEESALARYINFO = `${this.url_prod}/updateUserSalary`;
  LEAVEAPPROVE = `${this.url_prod}/leaveApprove`;

  // salary slip
  GETSALARY = `${this.url_prod}/getSalary/`;

  // SETTING --> department
  GETALLDEPARTMENT = `${this.url_prod}/getDepartment`;
  ADDDEPARTMENT = `${this.url_prod}/addDepartment`;
  GETALLDESIGNATIONBYDEPARTMENTID = `${this.url_prod}/getDesignation/`;
  ADDDESIGNATIONTODEPARTEMENTBYID = `${this.url_prod}/addDesignation`;
  DELETEDEPARTMENTBYID = `${this.url_prod}/deleteDepartment/`;
  DELETEDESIGNATIONBYID = `${this.url_prod}/deleteDesignation/`;

  //Attendance
  GETALLUSERATTENDANCE = `${this.url_prod}/findUserAttendance`;
  GETUSERATTENDANCEBYID = `${this.url_prod}/findUserAttendance`;
  GETALLDEPARTMENTWITHDESIGNATION = `${this.url_prod}/getDepartmentList`;
  ATTENDANCEAPPROVE = `${this.url_prod}/attendanceApprove`;

  CHANGEPASSWORD = `${this.url_prod}/auth/change-password`;
  USERUPDATE = `${this.url_prod}/userStatusUpdate`;
  LEADEXPORTACCESS = `${this.url_prod}/leadExportAccess`;
  UPDATESTAGE = `${this.url_prod}/updateLeadStage`;
  UPDATEAI = `${this.url_prod}/updateLeadAssignTo`;
  UPDATEREMINDER = `${this.url_prod}/addLeadReminder`;
  UPDATELEADREMINDER = `${this.url_prod}/updateLeadReminder`;
  UPDATEREMARK = `${this.url_prod}/addLeadRemark`;
  EDITREMARK = `${this.url_prod}/updateLeadRemark`;
  ASSIGNTOMEMBERS = `${this.url_prod}/updateLeadAssignToUser`;
  ADDPROJECTAPINEW = `${this.url_prod}/addProjectApiNew`;
  UPDATEPROJECTAPIEXISTING = `${this.url_prod}/updateProjectApiNew`;
  MOVEPROJECT = `${this.url_prod}/moveLeadFromUnmap`;
  DELETEREMARK = `${this.url_prod}/removeLeadReminder`;

  // organization
  getOrganizationByIds = `${this.url_prod}/getOrganizationByIds`;
  UPDATEORGANIZATION = `${this.url_prod}/updateOrganization`;
  ADDUPDATEORGANIZATION = `${this.url_prod}/addOrganiation`;

  ADDUSERLEAVE = `${this.url_prod}/addUserApplyLeave`;

  //projects
  PROJECTS = `/project`;
  PROJECTSASSETS = `/project/assets`;
  CREATEPROJECT = `/project/create`;
  AGGREGATOR = `/project/aggregator`;
  GETALLDEVELOPER = `${this.url_prod}/getDeveloper`;
  GETALLPROJECT = `${this.url_prod}/getProject`;
  GETPROJECTBYID = `${this.url_prod}/getProject/`;
  GETALLPROPERTYFOR = `${this.url_prod}/getPropertyFor`;
  GETALLPROPERTYTYPE = `${this.url_prod}/getPropertyType`;
  GETALLPROPERTYLIST = `${this.url_prod}/getPropertyList`;
  ADDALLPROPERTYLIST = `${this.url_prod}/addPropertyList`;
  UPDATEALLPROPERTYLIST = `${this.url_prod}/updatePropertyList`;
  GETALLPROPERTYUNITTYPE = `${this.url_prod}/getPropertyUnitType`;
  GETALLPROPERTYSTATUS = `${this.url_prod}/getPropertyStatus`;
  ADDDEVELOPER = `${this.url_prod}/addDeveloper`;
  ADDPROJECT = `${this.url_prod}/addProject`;
  ADDPROJECTDETAILS = `${this.url_prod}/addProjectDetail`;
  UPDATEPROJECTDETAILS = `${this.url_prod}/updateProjectDetail`;
  SAVEPROJECTUID = `${this.url_prod}/addProjectUidMapping`;
  GETPROJECTIDETAILS = `${this.url_prod}/getProjectUidMapping/`;
  UPDATELEADDEFORMTAILS = `${this.url_prod}/updateForm`;
  GETPROJECTLIST = `${this.url_prod}/getProjectDetails`;
  GETPROJECTLISTBYID = `${this.url_prod}/getProjectDetailById/`;
  GETPROJECTSBYTEAM = `${this.url_prod}/getProjectsByTeam`;
  ASSIGNUSERTOTEAMPROJECTS = `${this.url_prod}/assignUserToTeamProjects`;
  GETDEVELOPERTREE = `${this.url_prod}/getDeveloperTree`;
  GETDEVELOPERTREEBYID = `${this.url_prod}/getDeveloperTree/`;
  GETPROPERTYSTATUSBYID = `${this.url_prod}/getPropertyStatus/`;
  GETPROPERTYUNITTYPEBYID = `${this.url_prod}/getPropertyUnitType/`;

  GETADDPROPERTYFOR = `${this.url_prod}/addPropertyFor`;
  GETADDPROPERTYTYPE = `${this.url_prod}/addPropertyType`;
  GETADDPROPERTYUNITTYPE = `${this.url_prod}/addPropertyUnitType`;
  GETAddPROPERTYSTATUS = `${this.url_prod}/addPropertyStatus`;
  UPDATEPROJECTNAME = `${this.url_prod}/updateProject`;
  UPDATEDEVELOPERNAME = `${this.url_prod}/updateDeveloper`;

  GETUPDATEPROPERTYFOR = `${this.url_prod}/updatePropertyFor`;
  GETUPDATEPROPERTYTYPE = `${this.url_prod}/updatePropertyType`;
  GETUPDATEPROPERTYUNITTYPE = `${this.url_prod}/updatePropertyUnitType`;
  GETUPDATEPROPERTYSTATUS = `${this.url_prod}/updatePropertyStatus`;

  UPLOADIMAGE = `${this.url_prod}/upload-image`;
  UPLOADPRODUCTIMAGE = `${this.url_prod}/project-image`;
  UPLOADDEVELOPERIMAGE = `${this.url_prod}/developer-image`;



  //role
  ADDROLE = `${this.url_prod}/addRole`;
  UPDATEROLE = `${this.url_prod}/updateRole`;
  GETROLEBYID = `${this.url_prod}/getRole/`;
  GETROLE = `${this.url_prod}/getRole`;

  //role
  ADDTEAMMETA = `${this.url_prod}/addTeam`;
  UPDATETEAMMETA = `${this.url_prod}/updateTeam`;
  UPDATEDEPARTMENTMETA = `${this.url_prod}/updateDeveloper`;
  EDITDEPARTMENTMETA = `${this.url_prod}/updateDepartment`;
  GETTEAMMETALIST = `${this.url_prod}/getTeamList`;
  GETTEAMDROP = `${this.url_prod}/getTeamDropDown`;
  GETMEMBERSDROP = `${this.url_prod}/getMultipleTeamWiseDropDown`;
  ASSIGNLEADSTOMEMBERS = `${this.url_prod}/leadTransfer`;
  GETMEMBERSDROPPROJECT = `${this.url_prod}/getMultipleTeamWiseDropDownProject`;
  GETTEAMDROPPROJECT = `${this.url_prod}/getTeamDropDownProject`;
  GETALLSTAGE = `${this.url_prod}/getLeadStatus`;
  GETALLSOURSE = `${this.url_prod}/getLeadSource`;
  GETREMINDER = `${this.url_prod}/getLeadReminder/`;
  GETREMINDERALL = `${this.url_prod}/getLeadReminder`;
  GETREMARK = `${this.url_prod}/getLeadRemark/`;
  GETALLSALESHEAD = `${this.url_prod}/getAllSalesHead`;
  GETALLMANAGERBYTEAMWISE = `${this.url_prod}/getAllManagerByTeamWise/`;
  GETALLMANAGERBYROLE = `${this.url_prod}/getReportingManagerByRoleWise`;
  GETTASK = `${this.url_prod}/getLeadTask/`;
  ADDTASK = `${this.url_prod}/addLeadTask`

  ADDSTAGE = `${this.url_prod}/addLeadStage`
  GETSTAGEDATA = `${this.url_prod}/getLeadStage`
  UPDATESTAGENEW = `${this.url_prod}/updateLeadStageData`
  DELETESTAGEDATA = `${this.url_prod}/deleteLeadStage/`

  GETLEADHISTORY = `${this.url_prod}/getLeadHistory/`

  //add Loan
  ADDLOAN = `${this.url_prod}/addUserLoan`;
  UPDATELOAN = `${this.url_prod}/updateUserLoan`;
  GETLOANBYUSERID = `${this.url_prod}/findUserLoanList/`;
  GETLOANBYID = `${this.url_prod}/findUserLoanDeclaration/`;
  GETLOAN = `${this.url_prod}/findUserLoanDeclaration`;

  //Lead Form
  LEADFORMLIST = `/leadform`;
  ADDLEADFORMPAGE = `/leadform/add`;
  EDITLEADFORMPAGE = `/leadform/edit/:id`;
  ADDFORM = `${this.url_prod}/addForm`;

  // Feedback submissions
  FEEDBACKLIST = `/feedback`;
  REGISTRATIONSLIST = `/registrations`;
  PAYMENTLIST = `/payments`;

  //All leads
  // LEADDATA = `/getLeadList`;
  // GETSALESREPORT = `${this.url_prod}/addLead`
  ALLLEADFORMLIST = `/all-leads`;
  ALLLEADDETAILS = `/all-leads-details/:id`;
  ADDLEADPAGE = `/all-leads/add`;
  EDITLEADPAGE = `/all-leads/edit/:id`;
  HOMETATVALEADFORMLIST = `/hometatva-leads`;
  HOMETATVALEADDETAILS = `/hometatva-leads-details/:id`;
  ADDHOMETATVALEADPAGE = `/hometatva-leads/add`;
  EDITHOMETATVALEADPAGE = `/hometatva-leads/edit/:id`;
  ADDLEAD = `${this.url_prod}/addLead`;
  GETPRESALESREPORT = `${this.url_prod}/getPreSalesReport`;
  GETSALESREPORT = `${this.url_prod}/getSalesReport`;
  GETSOURCESREPORT = `${this.url_prod}/getSourceReport`;
  GETVISITSREPORT = `${this.url_prod}/getVisitReport`;
  GETPROJECTREPORT = `${this.url_prod}/getProjectReport`;
  GETCLOSUREREPORT = `${this.url_prod}/getClosureReport`;
  DELETETEAM = `${this.url_prod}/deleteTeam/`;
  AddSUBDEPARTMENT = `${this.url_prod}/addSubDepartment`
  GETSUBDEPARTMENT = `${this.url_prod}/getSubDepartment/`



  //Team Meta

  GETTEAMMETA = `${this.url_prod}/getTeamList/`
  AddSUBTEAM = `${this.url_prod}/addTeam`
  UPDATETEAM = `${this.url_prod}/updateSubTeam`
  DELETETEAMMETA = `${this.url_prod}/deleteSubTeam/`
  GETHIERARCHYMETA = `${this.url_prod}/getCompanyHierarchy`
  AddHIERARCHY = `${this.url_prod}/addCompanyHierarchy`
  GETPARENTHIERARCHY = `${this.url_prod}/getParentHierarchy`
  UPDATEHIERARCHY = `${this.url_prod}/updateCompanyHierarchy`
  DELETEHIERARCHY = `${this.url_prod}/deleteCompanyHierarchy/`
  GETALLREPORTINGMANAGER = `${this.url_prod}/getReportingManager/`;
  DASHBOARDTEAMSTAGECOUNT = `${this.url_prod}/getDashboardTeamStageCount`;
  DASHBOARDSALESTEAMSTAGECOUNT = `${this.url_prod}/getDashboardSalesTeamStageCount`;
  DASHBOARDPRESALESSTAGE = `${this.url_prod}/getPreSalesStage`;
  DASHBOARDSALESSTAGE = `${this.url_prod}/getSalesStage`;
  DASHBOARDPRESALESSTAGECOUNT = `${this.url_prod}/getDashboardPreSaleStageCount`;
  DASHBOARDSALESSTAGECOUNT = `${this.url_prod}/getDashboardSaleStageCount`;
  ADDPUSHNOTIFICATION = `${this.url_prod}/push-notification`;
  GETNOTIFICATION = `${this.url_prod}/getNotification`;
  ADDNOTIFICATIONTOKEN = `${this.url_prod}/auth/notification`;
  CLEARNOTIFICATIONTOKEN = `${this.url_prod}/auth/notification/clear`;
  GETTODAYREMINDERS = `${this.url_prod}/getAllTodayReminders`;
  ACKLEADREMINDER = `${this.url_prod}/ackLeadReminder`;
  GETTODAYSWORK = `${this.url_prod}/getTodaysWork`;
  GETMYPERFORMANCE = `${this.url_prod}/getMyPerformance`;
  SALESTARGETS = `${this.url_prod}/salesTargets`;
  TRANSFERUSERLEADS = `${this.url_prod}/transferUserLeads`;
  NOTIFICATIONPREFERENCES = `${this.url_prod}/notificationPreferences`;
  CHECKLEADDUPLICATE = `${this.url_prod}/checkLeadDuplicate`;
  RECYCLELEAD = `${this.url_prod}/recycleLead`;
  UPDATEPUSHNOTIFICATION = `${this.url_prod}/updateNotificationStatus`;
  UPDATECRONSETTINGS = `${this.url_prod}/updateCronJobSetting`;
  GETCRONSETTINGS = `${this.url_prod}/getCronJobSetting`;
  GETUNMAPFORM = `${this.url_prod}/getAllUnmapForm`;
  UPDATEUNMAPFORM = `${this.url_prod}/updateUnmapForm`;
  GETUNMERGELEADLIST = `${this.url_prod}/getUnmergeLeadList`;
  PROMOTEUNMERGELEADS = `${this.url_prod}/promoteUnmergeLeads`;
  DOWNLOADSLEADS = `${this.url_prod}/downloadLeads`
  DOENLOADSLEADSEXCEL = `${this.url_prod}/downloadLeadsExcel`
  GETIVRUSERS = `${this.url_prod}/getAllIVRUser`
  USERMAP = `${this.url_prod}/userMap`
  CLICKTOCALL = `${this.url_prod}/click2Call`
  CALLLOGDATA = `${this.url_prod}/callLogs`
  CALLINGREPORT = `${this.url_prod}/calling-report`
  CALLINGREPORTFILTERS = `${this.url_prod}/calling-report/filters`
  CALLINGREPORTLEADS = `${this.url_prod}/calling-report/leads`
  CALLINGREPORTEXPORT = `${this.url_prod}/calling-report/export`
  ACTIVECALLS = `${this.url_prod}/activeCalls`
  ACTIVECALLSEND = `${this.url_prod}/activeCalls/end`
  RECORDINGURL = `${this.url_prod}/recordingUrl`
  ADDPROJECTFILTERMETA = `${this.url_prod}/addProjectMeta`
  GETPROJECTFILTERMETA = `${this.url_prod}/getProjectMeta`
  GETPROJECTFILTERFIELDVALUES = `${this.url_prod}/getProjectFilterFieldValues`
  SYNCPROJECTFILTERMETA = `${this.url_prod}/syncProjectMetaFromProjects`
  ADDCOUNTRY = `${this.url_prod}/addCountry`
  ADDSTATE = `${this.url_prod}/addState`
  ADDCITY = `${this.url_prod}/addCity`
  DELETEPROJECTFILTERMETA = `${this.url_prod}/deleteProjectMeta/`
  ADDLOCATIONMETA = `${this.url_prod}/addLocationMeta/`
  GETLOCATIONMETA = `${this.url_prod}/getLocationMeta/`
  PROJECTREORDER = `${this.url_prod}/reorder`



  // Meeting url

  GOOGLEAUTH = `${this.url_prod}/google/auth-url`
  GOOGLEACCOUNT = `${this.url_prod}/google/accounts`
  MEETINGBASIC = `${this.url_prod}/basic`
  MEETING = `${this.url_prod}/meeting`
  HOSTMEETING = `${this.url_prod}/host-meeting/`
  MEETINGAVAILABILITY = `${this.url_prod}/availability/`
  MEETINGSCHEDULING = `${this.url_prod}/scheduling/`
  GENERATESLOTS = `${this.url_prod}/availability/generate-slots`
  Booking = `${this.url_prod}/getBookings`
  GETCUSTOMER = `${this.url_prod}/getCustomer`
  UPDATECUSTOMER = `${this.url_prod}/updateCustomer/`
  GETCUSTOMERACTIVITY = `${this.url_prod}/activity/`
  Enquiry = `${this.url_prod}/getEnquiry`
  ADDSECTOR = `${this.url_prod}/addSector`
  GETSECTOR = `${this.url_prod}/getSector`
  DELETESECTOR = `${this.url_prod}/deleteSector`
  ADDZONE = `${this.url_prod}/addZone`
  GETZONE = `${this.url_prod}/getZone`
  DELETEZONE = `${this.url_prod}/deleteZone`
  GETSUBSCRIBE = `${this.url_prod}/getSubscribe`


}
let urls = new UrlConstants();
export default urls;
